import { render } from "./404.vue?vue&type=template&id=17480c87"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"
script.render = render

export default script